// 3rd
import { Model } from '@vuex-orm/core';
export default class Challenge extends Model {
    static entity = 'challenges';

    static fields() {
        return {
            id: this.attr(null),
            isRunning: this.attr(null),
            rules: this.attr([]),
            scheduled_from_date: this.attr(null),
            scheduled_to_date: this.attr(null),
            title: this.attr(null),
            total_bonus_points: this.attr(null),
        }
    }

    // getters
    static getAll() {
        return Challenge.query().withAll().all();
    }
}
